import { render } from "./TramitesAsignaciones.vue?vue&type=template&id=5548e818&scoped=true"
import script from "./TramitesAsignaciones.vue?vue&type=script&lang=js"
export * from "./TramitesAsignaciones.vue?vue&type=script&lang=js"

import "./TramitesAsignaciones.vue?vue&type=style&index=0&id=5548e818&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5548e818"]])

export default __exports__